<template>
  <span class="sb-time-label">
    <!--
      @slot text, components, or HtmlElements as children of the component
     -->
    <slot />
  </span>
</template>

<script>
export default {
  name: 'SbTimeLabel',
};
</script>

<style lang="scss">
@import '@src/components/Timeline/style/sb-time-label.scss';
</style>
